// extracted by mini-css-extract-plugin
export default {"title":"Demo_title__OL-Is","container":"Demo_container__qgbkD","dark":"Demo_dark__3u+Pn"};